// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_DR2","cls2":"ReportList-cls2_TL6 ReportList-cls1_DR2"};